import { IdType } from 'types/common';

export const BRAZIL_ID: IdType = 1;
